module.exports = __webpack_public_path__ + "img/badge-list-thumb-123.1cb634ac.png";